// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"38d69c1e","244":"31476edf","391":"5e997b13","599":"ddc8f86a","779":"303a2f07","886":"e85c19c7","930":"0292dac7","971":"607853d4"}[chunkId] + ".chunk.css";
};